import { presenceState } from './staffPresenceModel';

const state = presence => presence?.is_online === true ? 'online' : presence?.is_online === false ? 'offline' : 'unknown';
export function rosterView(data) {
 if(!data)return null;
 return {whatsappLink:data.whatsapp_link||null,staff:(data.staff||[]).map(row=>({userId:row.user_id,displayName:row.display_name,pfp:row.pfp,srmPresence:state(row.srm_presence)}))};
}
export function transitionNotices(response){
 if(response.baseline!==false||response.data?.notifications_enabled!==true||!Array.isArray(response.data?.staff)||!Array.isArray(response.transitions))return [];
 const grouped=new Map();for(const t of response.transitions){if(t.source!=='srm'||typeof t.from!=='boolean'||typeof t.to!=='boolean'||t.from===t.to)continue;const row=response.data.staff.find(item=>item.user_id===t.user_id);if(!row)continue;const at=t.to?row.srm_presence?.online_since:row.srm_presence?.last_seen_at;if(!at)continue;const key=`${row.user_id}:srm:${t.from}:${t.to}:${at}`;grouped.set(key,{key,userId:row.user_id,name:row.display_name,source:'SRM',presence:presenceState(t.to?'online':'offline')});}return [...grouped.values()];
}

// One binding per header/session. No polling; GET bootstraps the view, socket
// snapshots replace it. A late HTTP response never overwrites socket state.
export function bindPresenceContract({ socket, channel, load, publish, error, notify }) {
  let active = true, generation = 0, receivedSocket = false, latestTime = -Infinity, hasSnapshot = false, currentView = null, linkHint = null;
  const receive = (response, current, source) => {
    if (!active || current !== generation || (source === 'http' && receivedSocket)) return;
    if (response?.success !== true) {
      if (source === 'socket') receivedSocket = true;
      hasSnapshot = false;
      publish(null);
      error(response?.message || 'Staff presence is unavailable.');
      return;
    }
    const data = response.data;
    if ((data?.channel_account_key && data.channel_account_key !== channel) || !Array.isArray(data?.staff)) return;
    const at = Date.parse(data.observed_at);
    if (!Number.isFinite(at) || at < latestTime) return;
    if (source === 'socket') receivedSocket = true;
    latestTime = at;
    const canAnnounce = hasSnapshot;
    hasSnapshot = true;
    error(null);
    currentView=rosterView(data);
    if(linkHint && Date.parse(linkHint.since)>=Date.parse(currentView.whatsappLink?.since||0))currentView={...currentView,whatsappLink:linkHint};
    publish(currentView);
    if (source === 'socket' && canAnnounce) transitionNotices(response).forEach(notice => notify?.(notice));
  };
  const onSnapshot = response => { if (socket.connected) receive(response, generation, 'socket'); };
  const reconcile = () => {
    const current = ++generation;
    receivedSocket = false; latestTime = -Infinity; hasSnapshot = false;
    publish(null); error(null);
    socket.emit('messaging:staff_presence:subscribe', { channel_account_key: channel }, response => {
      if (socket.connected) receive(response, current, 'socket');
    });
  };
  const unavailable = () => { currentView=null; generation++; receivedSocket = false; latestTime = -Infinity; hasSnapshot = false; publish(null); };
  const onLink=link=>{if(!active||!socket.connected)return;linkHint=link;if(currentView){currentView={...currentView,whatsappLink:link};publish(currentView);}};
  socket.on('messaging.whatsapp_link_changed',onLink);
  socket.on('messaging:staff_presence', onSnapshot);
  socket.on('connect', reconcile);
  socket.on('disconnect', unavailable);
  if (socket.connected) reconcile();
  const httpGeneration = generation;
  Promise.resolve().then(load).then(response => receive(response, httpGeneration, 'http'))
    .catch(() => { if (active && generation === httpGeneration && !receivedSocket) error('Could not load staff presence.'); });
  return () => {
    active = false; generation++;
    socket.off('messaging.whatsapp_link_changed',onLink);
    socket.off('messaging:staff_presence', onSnapshot);
    socket.off('connect', reconcile);
    socket.off('disconnect', unavailable);
    socket.emit('messaging:staff_presence:unsubscribe');
  };
}

// Web Locks makes the same-origin multi-tab claim atomic. Fail closed when
// locks/storage are unavailable: roster updates still work, only alerts stop.
export async function claimPresenceNotice(scope, key) {
  if (!navigator.locks?.request) return false;
  try {
    return await navigator.locks.request(`staff-presence:${scope}`, () => {
      const storageKey = `uzdpart360:presence-notices:${scope}`;
      const previous = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(previous) || previous.includes(key)) return false;
      localStorage.setItem(storageKey, JSON.stringify([...previous.slice(-99), key]));
      return true;
    });
  } catch { return false; }
}
